import { state } from '../state.js';

// Escape user-supplied text before interpolating it into innerHTML templates.
// Player names, clubs, tournament names etc. can be entered by anyone (incl.
// unauthenticated online registration), so they must never reach the DOM raw.
export function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
}

/*
 * A player's year of birth: the stored `birthYear` if there is one, otherwise the
 * year out of their `birthDate`. Returns '' when neither is known.
 *
 * The year is read off the ISO string rather than through `new Date(...)`: a
 * date-only string is parsed as UTC midnight, so west of Greenwich
 * `new Date('2015-01-01').getFullYear()` is 2014 — a child in the wrong age class.
 *
 * The two are separate fields on purpose. A tournament may ask its registrants for
 * one or the other (see js/ui/registration-fields.js), and everything that sorts
 * or groups by age reads the year.
 */
export function playerBirthYear(player) {
    const p = player || {};
    if (p.birthYear) return String(p.birthYear);
    const m = /^(\d{4})-\d{2}-\d{2}$/.exec(String(p.birthDate || '').trim());
    return m ? m[1] : '';
}

export function formatPlayerName(player, asHTML = false) {
    if (!player) return tr('Unknown');
    if (player.lastName === 'WO') return 'WO';
    if (player.lastName === 'BYE') return 'BYE';

    const given = player.givenName || '';
    const last = player.lastName || '';

    const nameStr = state.userProfile.nameFormat === 'first-last'
        ? (given ? (last ? `${given} ${last}` : given) : last)
        : (last ? (given ? `${last}, ${given}` : last) : given);

    if (player.title) {
        if (asHTML) {
            return `<span class="status-badge upcoming" style="margin-right: 0.5rem; font-size: 0.7rem; padding: 0.1rem 0.4rem;">${escapeHtml(player.title)}</span>` + escapeHtml(nameStr);
        } else {
            return `${player.title} ${nameStr}`;
        }
    }

    return asHTML ? escapeHtml(nameStr) : nameStr;
}